import { PaymentStatuses } from 'pejer/src/tables/Global'

export const paymentStatusLabels: Record<(typeof PaymentStatuses)[number], string> = {
  InitiatedPayment: 'Opprettet',
  ReservedPayment: 'Reservert',
  ChargedPayment: 'Betalt',
  RefundedPayment: 'Refundert',
  CancelledPayment: 'Kansellert',
  FailedPayment: 'Feilet',
  RefundInitiated: 'Refusjon startet',
  InvoiceConfirmed: 'Fakturert',
}
